export const DEFAULT_VALUES = {
  title: "",
  image: "",
  genre: "",
  rating: 0,
  actors: "",
  director: "",
  description: "",
  releaseDate: "",
};
